import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-center items-center gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Este recurso não foi compartilhado.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, {
      icon: $setup.mdiAlert,
      size: $props.iconSize,
      color: $props.iconColor
    }, null, 8, ["icon", "size", "color"]),
    _hoisted_2
  ]))
}